import { Response } from '@angular/http';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/observable/of';
import { UCSystem, MakeModelFamily, Compart, CompartType, ShoeSize, Make, SystemSetup, SystemModelTemplate, ComponentSetup, SystemStructureInformation, scrapedSystemId, ResultMessage } from '../../entities';
import { catchError, map } from 'rxjs/operators';
@Injectable()
export class SetupUndercarriageService {

    private _systemTemplate: SystemModelTemplate[] = [];
    private _currentModelId = 0;
    private _availableCompartTypes: CompartType[] = [
        { Id: 230, Title: 'Link', Order: 1 },
        { Id: 231, Title: 'Bushing', Order: 2 },
        { Id: 232, Title: 'Shoe', Order: 3 },
        { Id: 233, Title: 'Idler', Order: 5 },
        { Id: 234, Title: 'Carrier Roller', Order: 6 },
        { Id: 235, Title: 'Track Roller', Order: 7 },
        { Id: 236, Title: 'Sprocket', Order: 4 },
        { Id: 237, Title: 'Guard', Order: 8 },
        { Id: 240, Title: 'Track Elongation', Order: 9 },
    ];
    constructor(private _http: HttpClient) {
      _http.get('Api/Component/getAvailableCompartTypeList').pipe(catchError(this.handleError)).subscribe((result: any) => { this._availableCompartTypes = result; }, error => { this.handleError; }, () => { });
    }

    public getAvailableCompartTypeList(): CompartType[] {
        return this._availableCompartTypes;
    }

    public getEquipmentApplication(EquipmentId: number): Observable<any> {
      const options = {
        params: new HttpParams().set('EquipmentId', EquipmentId.toString())
      };
      return this._http.get('Api/Equipment/GetEquipmentApplication', options).pipe(catchError(this.handleError));
    }

    public GetEquipmentSystems(EquipmentId: number): Observable<UCSystem[]> {
      const options = {
        params: new HttpParams().set('EquipmentId', EquipmentId.toString())
      };
      return this._http.get<UCSystem[]>('Api/Equipment/getSystemList', options).pipe(catchError(this.handleError));
    }

    public GetSelectedSystemForSelectionInInventory(SystemId: number): Observable<UCSystem> {
      const options = {
        params: new HttpParams().set('SystemId', SystemId.toString())
      };
      return this._http.get<UCSystem>('Api/UCSystem/GetSelectedSystemForSelectionInInventory', options).pipe(catchError(this.handleError));
    }
    public GetEquipmentSmuAtSetup(EquipmentId: number): Observable<any> {
      const options = {
        params: new HttpParams().set('EquipmentId', EquipmentId.toString())
      };
      return this._http.get('Api/Equipment/getEquipmentSmuAtSetup', options).pipe(catchError(this.handleError));
    }

    public GetEquipmentDateAtSetup(EquipmentId: number): Observable<Date> {
      const options = {
        params: new HttpParams().set('EquipmentId', EquipmentId.toString())
      };
      return this._http.get<Date>('Api/Equipment/getEquipmentDateAtSetup', options).pipe(catchError(this.handleError));
    }

    public GetJobSiteSystems(JobSiteId: number): Observable<UCSystem[]> {
      const options = {
        params: new HttpParams().set('JobSiteId', JobSiteId.toString())
      };
      return this._http.get<UCSystem[]>('Api/JobSite/getSystemList', options).pipe(catchError(this.handleError));
    }

    public getSystemListForSetupInInventory(JobSiteId: number, PageNo: number, PageSize: number): Observable<UCSystem[]> {
      const options = {
        params: new HttpParams().set('JobSiteId', JobSiteId.toString()).set('PageNo', PageNo.toString()).set('PageSize', PageSize.toString())
      };
      return this._http.get<UCSystem[]>('Api/UCSystem/getSystemListForSetupInInventory', options).pipe(catchError(this.handleError));
    }

    public GetEquipmentMakeModelFamily(EquipmentId: number): Observable<MakeModelFamily> {
      const options = {
        params: new HttpParams().set('EquipmentId', EquipmentId.toString())
      };
      return this._http.get<MakeModelFamily>('Api/Equipment/GetEquipmentMakeModelFamily', options).pipe(catchError(this.handleError));
    }

    public GetSystemMakeModelFamily(SystemId: number): Observable<MakeModelFamily> {
      const options = {
        params: new HttpParams().set('SystemId', SystemId.toString())
      };
      return this._http.get<MakeModelFamily>('Api/UCSystem/GetSystemMakeModelFamily', options).pipe(catchError(this.handleError));
    }

    public GetAvailableComparts(CompartTypeId: number, ModelId: number): Observable<Compart[]> {
      const options = {
        params: new HttpParams().set('CompartTypeId', CompartTypeId.toString()).set('ModelId', ModelId.toString())
      };
      return this._http.get<Compart[]>('Api/Component/getCompartList', options).pipe(catchError(this.handleError));
    }

    public GetAvailableCompartsAll(ModelId: number): Observable<Compart[]> {
      const options = {
        params: new HttpParams().set('ModelId', ModelId.toString())
      };
      return this._http.get<Compart[]>('Api/Component/getCompartListAll', options).pipe(catchError(this.handleError));
    }

    public GetTemplateForModel(ModelId: number): Observable<SystemModelTemplate[]> {
        this._systemTemplate = [];
        const options = {
          params: new HttpParams().set('ModelId', ModelId.toString())
        };
        return this._http.get<SystemModelTemplate[]>('Api/UCSystem/GetTemplateForModel', options).pipe(
          map((response: any) => {
            this._systemTemplate.push(...response);
            return response;
          }),
          catchError(this.handleError)
        );
    }

    public GetTemplateForEquipment(EquipmentId: number): Observable<SystemModelTemplate[]> {
        this._systemTemplate = [];
        const options = {
          params: new HttpParams().set('EquipmentId', EquipmentId.toString())
        };
        return this._http.get<SystemModelTemplate[]>('Api/UCSystem/GetTemplateForEquipment', options).pipe(
          map(
            (response: any) => {
              this._systemTemplate.push(response);
              return response;
            }),
          catchError(this.handleError)
        );
    }

    public GetEquipmentUnsyncedId(EquipmentId: number): Observable<any> {
      const options = {
        params: new HttpParams().set('EquipmentId', EquipmentId.toString())
      };
      return this._http.get('Api/Inspection/GetEquipmentUnsyncedId', options).pipe(catchError(this.handleError));
    }

    public getShoeSizeList(): Observable<ShoeSize[]> {
      return this._http.get<ShoeSize[]>('Api/Component/getShoeSizeList').pipe(catchError(this.handleError));
    }

    public getCleanerHolesList(): Observable<ShoeSize[]> {
      return this._http.get<ShoeSize[]>('Api/Component/getCleanerHolesList').pipe(catchError(this.handleError));
    }
    public getComponentMakeList(): Observable<Make[]> {
      return this._http.get<Make[]>('Api/Application/getComponentMakeList').pipe(catchError(this.handleError));
    }

    public getModelTemplateListForChain( templateList: SystemModelTemplate[]): SystemModelTemplate[] {
        return templateList.filter(m => m.CompartTypeId === 230 || m.CompartTypeId === 231 || m.CompartTypeId === 232 || m.CompartTypeId===240);
    }

    public getModelTemplateListForFrame(templateList: SystemModelTemplate[]): SystemModelTemplate[] {
        return templateList.filter(m => m.CompartTypeId !== 230 && m.CompartTypeId !== 231 && m.CompartTypeId !== 232 && m.CompartTypeId !== 240);
    }

    public getModelTemplateListForIdler( templateList: SystemModelTemplate[]): SystemModelTemplate[] {
      return templateList.filter(m => m.CompartTypeId === 233);
  }

    public getModelTemplateListForAllSystems(): SystemModelTemplate[] {
        return this._systemTemplate;
    }

    public createSystem(body: SystemSetup): Observable<SystemSetup> {
      return this._http.post<SystemSetup>('Api/UCSystem/CreateSystem', body).pipe(catchError(this.handleError));
    }

    public updateSystem(body: SystemSetup): Observable<SystemSetup> {
      return this._http.post<SystemSetup>('Api/UCSystem/UpdateSystem', body).pipe(catchError(this.handleError));
    }

    public installSystem(body: SystemSetup): Observable<SystemSetup> {
      return this._http.post<SystemSetup>('Api/UCSystem/InstallSystem', body).pipe(catchError(this.handleError));
    }

    public checkSystemSerialNo(serialNo: string): Observable<any> {
        const options = {
            params: new HttpParams().set('SerialNo', serialNo)
        };
        return this._http.get('Api/UCSystem/CheckSystemSerialNo', options).pipe(catchError(this.handleError));
    }

    public createComponent(body: ComponentSetup): Observable<ComponentSetup> {
      return this._http.post<ComponentSetup>('Api/Component/CreateComponent', body).pipe(catchError(this.handleError));
    }

    public createAndInstallComponents(body: SystemSetup): Observable<SystemSetup> {
      return this._http.post<SystemSetup>('Api/Component/CreateAndInstallComponents', body).pipe(catchError(this.handleError));
    }

    public getSystemForSetupUpdate(systemId: number): Observable<SystemSetup> {
      const options = {
        params: new HttpParams().set('SystemId', systemId.toString())
      };
      return this._http.get<SystemSetup>('Api/UCSystem/GetSystemForSetupUpdate', options).pipe(catchError(this.handleError));
    }

    public submit4SystemsOnEquipment(body: SystemSetup[]): Observable<SystemSetup[]> {
      return this._http.post<SystemSetup[]>('Api/UCSystem/submit4SystemsOnEquipment', body).pipe(catchError(this.handleError));
    }

    public submit2SystemsInInventory(body: SystemSetup[]): Observable<SystemSetup[]> {
      return this._http.post<SystemSetup[]>('Api/UCSystem/submit2SystemsInInventory', body).pipe(catchError(this.handleError));
    }

  public ManageSystemInInventoryDetail(body: SystemSetup[]): Observable<any> {
    return this._http.post('Api/UCSystem/ManageSystemInInventoryDetail', body).pipe(catchError(this.handleError));
  }
    public getFamilyList() {
      return this._http.get<any>('Api/SetupFamily/getAllFamilyList').pipe(catchError(this.handleError));
    }

    public getEquipmentFamily(equipmentId: number) {
        const options = {
            params: new HttpParams().set('equipmentId', equipmentId.toString())
        };
        return this._http.get('Api/SetupFamily/getEquipmentFamily', options).pipe(catchError(this.handleError));
    }

    public getSystemFamily(systemId: number) {
        const options = {
            params: new HttpParams().set('systemId', systemId.toString())
        };
        return this._http.get('Api/SetupFamily/getSystemFamily', options).pipe(catchError(this.handleError));
    }



    GetSystemStructureInfo(systemId: number): Observable<SystemStructureInformation>  {
      const options = {
        params: new HttpParams().set('systemId', systemId.toString())
    };
      return this._http.get<SystemStructureInformation>('Api/SetupFamily/GetSystemStructureInfo', options).pipe(catchError(this.handleError));
    }

    public CheckEquipmentIsSetup(EquipmentId: number): Observable<any> {
      const options = {
        params: new HttpParams().set('EquipmentId', EquipmentId.toString())
      };
      return this._http.get('Api/UCSystem/CheckEquipmentSetupId', options).pipe(catchError(this.handleError));
  }

  public setSystemAsScraped(systemId: string): Observable<void> {
    const systemIdsPayload: scrapedSystemId = { SystemId: systemId };
    return this._http.post<void>('Api/UCSystem/SetSystemAsScraped', systemIdsPayload)
      .pipe(catchError(this.handleError));
  }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

  public ValidateSerialNo(customerId: number, SerialNo: string): Observable<ResultMessage> {
    const options = {
      params: new HttpParams().set('CustomerId', customerId.toString()).set('SerialNo', SerialNo)
    };
    return this._http.get<ResultMessage>('Api/UCSystem/ValidateSerialNo', options).pipe(catchError(this.handleError));
  }
}
